import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import './assets/styles.css'
import './assets/stora-ui.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import axios from 'axios'

import App from './App.vue'
import router from './router'
import Toast from 'vue-toastification'
import i18n from './i18n'
import 'vue-toastification/dist/index.css'

// Imported for its SIDE EFFECT: usePush attaches the `beforeinstallprompt` listener
// at module scope, and that event fires early in page load. Importing here guarantees
// it is attached in time no matter how components are loaded — without this, the
// install button depends on Settings.vue happening to be statically imported.
import '@/composables/usePush'

// Always attach the auth token from localStorage on every request. The token is
// persisted, but axios.defaults headers are in-memory and reset on a full page
// reload (F5) — so calls that relied on the default (e.g. the coach endpoints)
// would 401 after a refresh until the next login. An interceptor fixes it for
// every request, surviving reloads.
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken')
  if (token) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

const app = createApp(App)

app.use(router)
app.use(i18n)

app.use(Toast, {
    // You can set your default options here
    timeout: 5000, // 5 seconds
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: 'button',
    icon: true,
    rtl: false,
  })

//!!!!!Define as last line before mounting => It avoids errors with pinia store is created before used!!!!//
app.use(createPinia())

app.mount('#app')

// Register the service worker (PWA install + Web Push, docs/15 C). Push itself is
// opt-in per user via Settings; this just makes the worker available. Failures are
// non-fatal — the app works without it.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('Service worker registration failed:', err)
    })
  })
}